<template>

  <v-card-text class="">
    <div class="title">Send quotation</div>
    <p class="subtitle">
      Send quotation using this template?
    </p>

    <div class="actions">
      <AppButtonFlat
        block
        type="button"
        :prepend-icon="isSubmitting ? undefined : 'mdi-check-circle-outline'"
        :loading="isSubmitting"
        :disabled="
          isSubmitting ||
          inquiryIdValue == null ||
          String(inquiryIdValue).trim() === '' ||
          quotationTemplateIdValue == null ||
          String(quotationTemplateIdValue).trim() === ''
        "
        @click="handleConfirm"
      >
        Confirm
      </AppButtonFlat>
    </div>
  </v-card-text>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { sendQuotation } from "@/shared/services/quotations.api";
import { useSnackbarStore } from "@/shared/stores/snackbar";

const props = defineProps<{
  inquiryId: string | number;
  quotationTemplateId: string | number;
  summary?: {
    sub_total?: number;
    tax?: number;
    online_fee?: number;
    total?: number;
  };
  onSuccess?: () => void | Promise<void>;
}>();

const modal = useModalStore();
const snackbar = useSnackbarStore();
const isSubmitting = ref(false);

const inquiryIdValue = computed(() => props.inquiryId);
const quotationTemplateIdValue = computed(() => props.quotationTemplateId);

async function handleConfirm() {
  if (isSubmitting.value) return;

  isSubmitting.value = true;
  try {
    if (inquiryIdValue.value == null || String(inquiryIdValue.value).trim() === "") {
      snackbar.error("Inquiry ID missing.");
      return;
    }
    if (
      quotationTemplateIdValue.value == null ||
      String(quotationTemplateIdValue.value).trim() === ""
    ) {
      snackbar.error("Template ID missing.");
      return;
    }

    await sendQuotation(inquiryIdValue.value, {
      quotation_template_id: quotationTemplateIdValue.value,
      summary: props.summary ?? undefined,
    });
    snackbar.success("Quotation sent.");
    await props.onSuccess?.();
    modal.close();
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Unable to send quotation.";
    snackbar.error(message);
  } finally {
    isSubmitting.value = false;
  }
}
</script>

<style scoped>
.use-template-modal-body {
  padding: 0 0 calc(env(safe-area-inset-bottom, 0px) + 8px);
}

.title {
  font-size: 16px;
  font-weight: 700;
  color: var(--color-title);
}

.subtitle {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 14px;
}

.actions {
  margin-top: 16px;
}
</style>
